import { IconButton } from 'app/components/ui/IconButton/IconButton';
import { i18n } from 'app/utils/i18n';
import { FilterGroup } from './useFilteredTags';

import './FilterResults.scss';

interface FilterResultProps {
  filters: { [group: string]: string[] };
  onRemove: (group: string, value: string) => void;
  filterGroups?: FilterGroup[];
}

export const FilterResults = ({ filters, onRemove, filterGroups }: FilterResultProps) => {
  if (!filters || Object.keys(filters).length === 0) return null;

  const filterLabels = [
    { label: 'IFRS-FULL', value: 'ifrsFull' },
    { label: 'ESRS-2025', value: 'esrs2025' },
    { label: i18n('tag.status.approved'), value: 'approved' },
    { label: i18n('tag.status.draft'), value: 'draft' },
    { label: i18n('tag.status.need_attention'), value: 'need_attention' },
    { label: i18n('tag.status.verified'), value: 'verified' },
    { label: i18n('tag.status.invalid'), value: 'invalid' },
    { label: i18n('tag.status.unvalidated'), value: 'unvalidated' },
    { label: i18n('tag.status.valid'), value: 'valid' },
    { label: i18n('tag.type.numeric'), value: 'nonFraction' },
    { label: i18n('tag.type.textBlock'), value: 'nonNumeric' },
    { label: i18n('tag.type.fraction'), value: 'fraction' },
  ];

  const resolveLabel = (group: string, value: string): string => {
    if (filterGroups) {
      const groupObj = filterGroups.find((g) => g.value === group);
      const option = groupObj?.options.find((opt) => opt.value === value);
      if (option) return option.label;
    }
    const optionObj = filterLabels.find((opt) => opt.value === value);
    return optionObj?.label || value;
  };

  return (
    <div className="filter__selected-filters">
      {Object.entries(filters).map(([group, values]) =>
        values?.map((value) => {
          return (
            <span key={group + value} className="filter__selected--pill">
              {resolveLabel(group, value)}
              <IconButton icon="close" variant="transparent" onClick={() => onRemove(group, value)} />
            </span>
          );
        })
      )}
    </div>
  );
};
